import React, {useEffect} from "react";
import {BusinnesWrap} from "components/atoms/BusinessSetup/BusinessSetup.styles";
import Heading from "components/atoms/Auth/Heading";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import Button from "components/molecules/Button";
import {useForm} from "components/molecules/Form";
import {useDispatch} from "react-redux";
import {useSelector} from "react-redux";
import {setBusinessSetup5} from "store/reducers/businessSlice";

const bankData = [{label: "State Bank of America", value: "State Bank of America"}];

const BankInfo = ({handleSubmit, loading, cuisine_data}) => {
    const [form] = useForm();
    const dispatch = useDispatch();
    const {businessSetup5} = useSelector(state => state.business);

    const onSubmit = values => {
        dispatch(setBusinessSetup5(values));
        handleSubmit(values, cuisine_data);
    };

    useEffect(() => {
        if (businessSetup5 && Object.keys(businessSetup5).length > 0) {
            form.setFieldsValue({
                bank_name: bankData?.find(data => data.value === businessSetup5?.bank_name?.value),
                account_no: businessSetup5?.account_no,
                transit_number: businessSetup5?.transit_number,
                bank_code: businessSetup5?.bank_code,
                account_title: businessSetup5?.account_title,
            });
        }
    }, [businessSetup5, form]);
    return (
        <BusinnesWrap>
            <Heading
                heading="Link your"
                ColoredText="Bank Account!"
                para="Please link your bank account to receive payments, your details are secure & encrypted with us."
            />
            <Form form={form} onSubmit={onSubmit}>
                <Form.Item
                    label="Bank Name *"
                    type="select"
                    rounded
                    name="bank_name"
                    lg
                    placeholder="Select Bank Name"
                    $bgWhite
                    options={bankData}
                    rules={[
                        {
                            required: true,
                            message: "Bank name is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>
                <Form.Item
                    label="Account No *"
                    type="text"
                    rounded
                    name="account_no"
                    lg
                    placeholder="Add Account No"
                    $bgWhite
                    rules={[
                        {
                            required: true,
                            message: "Account No is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>
                <div className="signup-fields">
                    <Form.Item
                        label="Transit Number *"
                        type="text"
                        rounded
                        name="transit_number"
                        lg
                        placeholder="Enter Transit Number"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Transit Number is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>

                    <Form.Item
                        label="Bank code *"
                        type="text"
                        rounded
                        name="bank_code"
                        lg
                        placeholder="Enter Bank Code"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Bank code is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                </div>
                <Form.Item
                    label="Account Title *"
                    type="text"
                    rounded
                    name="account_title"
                    lg
                    placeholder="Add Account Title"
                    $bgWhite
                    rules={[
                        {
                            required: true,
                            message: "Account Title is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>
                <div className="btn-holder">
                    <Button lg type="submit" loader={loading}>
                        Submit
                    </Button>
                </div>
            </Form>
        </BusinnesWrap>
    );
};

export default BankInfo;
